export const MasterCard = () => (
  <svg
    height="32px"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g className="nc-icon-wrapper">
      <rect
        fill="#fff"
        height="18"
        rx="3"
        ry="3"
        strokeWidth="0"
        width="28"
        x="2"
        y="7"
      />
      <path
        d="m27,7H5c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3v-12c0-1.657-1.343-3-3-3Zm2,15c0,1.103-.897,2-2,2H5c-1.103,0-2-.897-2-2v-12c0-1.103.897-2,2-2h22c1.103,0,2,.897,2,2v12Z"
        opacity=".15"
        strokeWidth="0"
      />
      <path
        d="m27,8H5c-1.105,0-2,.895-2,2v1c0-1.105.895-2,2-2h22c1.105,0,2,.895,2,2v-1c0-1.105-.895-2-2-2Z"
        fill="#fff"
        opacity=".2"
        strokeWidth="0"
      />
      <path
        d="M13.597 11.677H18.407V20.32H13.597z"
        fill="#ff5f00"
        strokeWidth="0"
      />
      <path
        d="m13.902,15.999c0-1.68.779-3.283,2.092-4.322-2.382-1.878-5.849-1.466-7.727.932-1.863,2.382-1.451,5.833.947,7.712,2,1.573,4.795,1.573,6.795,0-1.329-1.038-2.107-2.642-2.107-4.322Z"
        fill="#eb001b"
        strokeWidth="0"
      />
      <path
        d="m24.897,15.999c0,3.039-2.459,5.497-5.497,5.497-1.237,0-2.428-.412-3.39-1.176,2.382-1.878,2.795-5.329.916-7.727-.275-.336-.58-.657-.916-.916,2.382-1.878,5.849-1.466,7.712.932.764.962,1.176,2.153,1.176,3.39Z"
        fill="#f79e1b"
        strokeWidth="0"
      />
    </g>
  </svg>
);
